import { t } from "@lingui/macro";
import * as React from "react";
import { Path } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const StoreIcon = (props: IconProps) => (
  <Icon
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    title={t`Store`}
    {...props}
  >
    <Path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M4 6h8l1 9H3l1-9ZM6 4a2 2 0 1 1 4 0"
    />
  </Icon>
);
